import { render, staticRenderFns } from "./MessagesListItemSlim.vue?vue&type=template&id=53762923&scoped=true&"
import script from "./MessagesListItemSlim.vue?vue&type=script&lang=ts&"
export * from "./MessagesListItemSlim.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesListItemSlim.vue?vue&type=style&index=0&id=53762923&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53762923",
  null
  
)

export default component.exports